<template>
    <div class="fullContainer">
        <div class="container calendar">
            <div class="row calendar-weekdays">
                <div class="col calendarDayOfWeek__th" v-for="n in 7" :key="n">
                {{ youbi(n-1) }}
                </div>
            </div>
            <div class="row calendarPager">
                <div class="customContainer">
                    <ul class="calendar__ul d-flex align-items-center justify-content-between">
                    <li class="calendarPager__button"><a class="calendarPager__link calendarPager__link--prev" @click="calendarPrev">Prev</a></li>
                    <li class="calendarPager__date">{{ currentCalendarLabel }}</li>
                    <li class="calendarPager__button"><a class="calendarPager__link calendarPager__link--next" @click="calendarNext">Next</a></li>
                    </ul>
                </div>
            </div>
            <div class="row topCalendar"
                v-for="(week, index) in calendars"
                :key="index"
                >
                <div class=" col p-0"
                    :class="{outside: currentMonth !== day.month}"
                    v-for="(day, index) in week"
                    :key="index"
                    >
                        <div
                            v-if="(currentMonth !== day.mon_num) || past_day(day)"
                            class="topCalendar__cell topCalendar__cell--inactive" style="width:100%;">
                            <span class="topCalendar__date">{{ day.day }}</span><span class=" d-none topCalendar__status">○</span>
                        </div>
                        <div
                            v-else
                            @click="selectDay(day.day)"
                            style="width:100%;"
                            :class="' topCalendar__cell '">
                            <div v-if="selectMode == 'drive' && vue_node_env != 'production'">
                                <div style="padding-top: 45%;">
                                    <span v-if="dateReserveChk(day.day) >=1000" class="text-secondary">{{ day.day }}</span>
                                    <span v-else-if="dateReserveChk(day.day) >=100" class="text-secondary">{{ day.day }}</span>
                                    <span v-else-if="dateReserveChk(day.day) >=10">{{ day.day }}</span>
                                    <span v-else>{{ day.day }}</span>
                                </div>
                                <!-- <span class="topCalendar__date">{{ day.day }}</span> -->
                            </div>
                            <label 
                                v-else
                                class="topCalendar__label d-flex justify-content-center align-items-center" 
                                :for="'topCalendarCell' + day.day"
                                >
                                <span class="topCalendar__date">{{ day.day }}</span>
                                <span class="topCalendar__status" v-if="dateStateChk(day.day)">
                                    <span v-if="dateReserveChk(day.day) >=1000">×</span>
                                    <span v-else-if="dateReserveChk(day.day) >=100">△</span>
                                    <span v-else-if="dateReserveChk(day.day) >=10">○</span>
                                    <span v-else>○</span>
                                    <!-- <input :value="get_node_by_date(day.day)"> -->
                                </span>
                                <span class="topCalendar__status" v-else-if="loadingFinishObj">×</span>
                                <span class="topCalendar__status loading" v-else><div class="spinner-border" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
                                </span>
                            </label>
                        </div>
                </div>
            </div>
            <!--  -->
        </div>
        <p class="top__reserveButton">
            <!-- <button class="button02" type="submit">予約する</button> -->
        </p>
    </div>
</template>
<style>
    .loading {
        animation:3s linear infinite rotation1;
    }
@keyframes rotation1{
  0%{ transform:rotate(0);}
  100%{ transform:rotate(360deg); }
}
</style>
<script>
import moment from "moment"
import { mapState } from "vuex";
export default {
    name: 'BsCalendarView',
    data: function () {
        return {
            // currentDate: moment(),
            sel_month: '',
            sel_now_key: 12,
        }
    },
    props: {
        reserve_num: {
            type: Number,
            default: 0
        },
        consecutive_cnt: {
            type: Number,
            default: 0
        },
        facility_group_id: {
            type: Number,
            default: 0
        },
        selectMode: {
            type: String,
            default: ''
        },
        dateDataObj: {
            type: Array,
            default: () => []
        },
        selectDateObj: {
            type: Array,
            default: () => []
        },
        loadingFinishObj: {
            type: Boolean,
            default: false
        },
        currentDateObj: {
            type: String,
            default: ''
        }
    },
    components: {
    },
    mounted(){
    },
    methods: {
        selectDay(day){
            console.log('selectDay', day);
            const dateObj = moment(this.currentDate);
            const td = (parseInt(day)<10)? '0'+ day: day;
            const m = moment(dateObj.format("YYYY-MM") + '-' + td);
            const today = moment().format('YYYY-MM-DD');
            const tomorrow = moment().add('days', 1).format('YYYY-MM-DD');
            if( 
                this.dateReserveChk(day) < 1000
                && 
                (
                    this.dateStateChk(day) == true 
                    || (
                        this.dateStateChk(day) == false 
                        && 
                        (
                            today == m.format('YYYY-MM-DD')
                            || tomorrow == m.format('YYYY-MM-DD')
                        )
                    )
                )
            ){
                console.log('selectDay sel', day);
                let tmpDate = [...this.selectDate];
                if(this.selectMode == 'drive'){
                    tmpDate = [];
                }

                tmpDate.push(m.format("YYYY-MM-DD"));
                this.selectDate = tmpDate;
            }else{
                console.log('selectDay not', day);
            }
        },

        // calender
        calendarAction(mode){

            if(mode == 'next'){
                this.calendarNext();
            }
            else if(mode == 'prev'){
                this.calendarPrev();
            }
        },
        calendarPrev() {
            console.log('calendarPrev', this.currentDate);
            let date = moment(this.currentDate);
            this.currentDate = date.subtract('months', 1);
            // this.$emit('to_push_select_date', value);
        },
        calendarNext() {
            console.log('calendarPrev', this.currentDate);
            let date = moment(this.currentDate);
            this.currentDate = date.add('months', 1);
        },
        getStartDate() {
            console.log('calendarPrev', this.currentDate);
            const date = moment(this.currentDate);
            date.startOf("month");
            const youbiNum = date.day();
            return date.subtract(youbiNum, "days");
        },
        getEndDate() {
            console.log('getEndDate', this.currentDate);
            // console.log('getEndDate getNode');
            const date = moment(this.currentDate);
            date.endOf("month");
            const youbiNum = date.day();
            return date.add(6 - youbiNum, "days");
        },
        getCalendar() {
            let startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const weekNumber = Math.ceil(endDate.diff(startDate, "days") / 7);
            console.log('getCalendar', startDate.year(), endDate.month(), weekNumber);

            let calendars = [];for (let week = 0; week < weekNumber; week++) {
            let weekRow = [];
            for (let day = 0;  day < 7; day++) {
                weekRow.push({
                    month: startDate.format("YYYY-MM"),
                    mon_num: startDate.get('month') + 1,
                    day: startDate.get("date"),
                    day_num: startDate.format("YYYYMMDD"),
                });
                startDate.add(1, "days");
                }
                calendars.push(weekRow);
            }
            return calendars;
        },
    },
    created () {
    //   this.sel_month = this.month_list[12].key;
    },
    computed: {
      ...mapState({
        user: state => state.apidata.user,
      }),
      past_day: function(){
        return function(day){
            const m = moment();
            // console.log('past_day',day, m.format('D'));
            if(parseInt(day.day_num) < parseInt(m.format("YYYYMMDD"))){
                return true;
            }
            return false;
        }
      },
      currentDate: {
        get: function (){
            console.log('this.currentDateObj', this.currentDateObj);
            if(this.currentDateObj){
                return moment(this.currentDateObj);
            }
            return moment();
        },
        set: function(value){
            console.log(value);
            this.$emit('set_current_date', value);
        }
      },
      selectDate: {
        get: function (){
            return this.selectDateObj;
        },
        set: function(value){
            this.$emit('to_push_select_date', value);
        }
    },
      currentCalendarLabel: function(){
        const date = moment(this.currentDate);
        return date.format('YYYY . M');
      },
      currentMonth:function(){
        const date = moment(this.currentDate);
        return date.month() + 1;
      },
      youbi: function () {
        const week = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        return function(dayIndex){
            return week[dayIndex];
        }
      },

      month_list: function(){
            const list = {};
            for(let i = 0;i<24;i++){
              console.log('month_list', i, this.sel_date);
                const targetDate = moment(this.sel_date).add(
                    (i - this.sel_now_key), 'month'
                );
              console.log('month_list+', targetDate);
                list[i] = {
                    label:  targetDate.get('year') + '年' + String(targetDate.get('month') + 1) + '月',
                    key: targetDate.get('year') + '-' + String(targetDate.get('month') + 1)
                }
            }
            return list;
        },
      calendars() {
          return this.getCalendar();
      },
      dateStateChk: function () {
        const dateData = this.dateDataObj;
        const dateObj = moment(this.currentDate);

        return function (day){
            const td = (parseInt(day)<10)? '0' + day: day;
            const m = moment(dateObj.format("YYYY-MM") + '-' + td);
            const chk = dateData.find(data => {
                return (data.range_start_date == m.format('YYYY-MM-DD'));
            });
            return (chk)? (this.dateReserveChk(day) < 1000)? true: false: false;
        }
      },
      dateReserveChk:function(){
        const dateObj = (typeof this.dateDataObj === 'object')? this.dateDataObj.filter(obj => {
            if(moment(obj.range_start_date).format('MM') == moment(this.currentDate).format('MM')){
                return true;
            }
            return false;
        }): [];
        const selectMode = this.selectMode;
        const dateReserveLimit = this.dateReserveLimit;
        const dateReserveCount = this.dateReserveCount;
        const threshold = (this.selectMode == 'drive')? 6: (this.selectMode == 'lodge')? 1: 1;
        const reserve_num = (this.reserve_num);
        return function (day){
            const reserve_count = parseInt(reserve_num) + parseInt(dateReserveCount(day));
            console.log('reserve_count', this.selectMode, day, reserve_count, dateReserveLimit(day));
            if(typeof dateObj !== 'object' || (typeof dateObj === 'object' && Object.keys(dateObj).length <= 0)){
                return 1000;
            }
            // オーバー×
            else if(
                dateReserveLimit(day) > 0
                && dateReserveLimit(day) < reserve_count
            ){
                return 1000;
            }
            else if(
                selectMode == 'lodge'
                && parseInt(dateReserveCount(day)) >= 1
            ){
                return 100;
            }
            else if(
                dateReserveLimit(day) > 0
                && dateReserveLimit(day) <= parseInt(dateReserveCount(day))
            ){
                return 1000;
            }
            // 制限ありで残数がしきい値以下△
            else if(
                dateReserveLimit(day) > 0
                && (dateReserveLimit(day) - reserve_count) <= threshold
            ){
                return 100;
            }
            // 制限ありで残数がしきい値以上○
            else if(
                dateReserveLimit(day) > 0
                && (dateReserveLimit(day) - reserve_count) > threshold
            ){
                return 10;
            }
            //制限無し
            else{
                return 0;
            }
        }
      },
      get_node_by_date: function () {
        const dateData = this.dateDataObj;
        const dateObj = moment(this.currentDate);
        return function (day){
            const td = (parseInt(day)<10)? '0' + day: day;
            const m = moment(dateObj.format("YYYY-MM") + '-' + td);
            const nodes = [];
            dateData.forEach(data => {
                if(
                    data.range_start_date == m.format('YYYY-MM-DD')
                ){
                    nodes.push(data);
                }
            });
            if(day == '13') console.log('get_node_by_date', nodes);

            return nodes;
        }
      },
      dateReserveLimit: function () {
        const dateData = this.dateDataObj;
        const dateObj = moment(this.currentDate);
        return function (day){
            const td = (parseInt(day)<10)? '0' + day: day;
            const m = moment(dateObj.format("YYYY-MM") + '-' + td);
            let limit = 0;
            dateData.forEach(data => {
                if(
                    data.range_start_date == m.format('YYYY-MM-DD')
                ){
                    limit = limit + parseInt(data.reserve_limit);
                }
            });

            return (limit)? limit: 0;
        }
      },
      dateReserveCount: function () {
        const dateData = this.dateDataObj;
        const dateObj = moment(this.currentDate);

        return function (day){
            const td = (parseInt(day)<10)? '0' + day: day;
            const m = moment(dateObj.format("YYYY-MM") + '-' + td);
            let cnt = 0;
            dateData.forEach(data => {
                    // if(parseInt(day) == 28 && data.range_start_date == '2023-10-28') console.log('dateReserveCount', data.reserved);
                if(
                    data.range_start_date == m.format('YYYY-MM-DD')
                    && typeof data.reserved === 'object'
                ){
                    Object.values(data.reserved).forEach(reserve => {
                        if(parseInt(reserve.is_cancel) == 0){
                            cnt = cnt+1;
                        }
                    })
                    // cnt = cnt + Object.keys(data.reserved).length
                }
            });
            return cnt;
        }
      },
      dayClassStat: function(){
          // const selday = this.sel_day;
          return function (day){
            console.log(day);
              // 選択中
              // if(Object.keys(selday).find((val)=> {return val == day})){
              // if(this.daySelectedChk(day)){
              //     // console.log('dayclassstat 一致', day);
              //     return ' selected_day';
              // }
              // // 設定済
              // // else if(Object.keys(this.lodge_node).length > 0 && this.lodge_node.find((val) =>{return val.day_key == day})){
              // else if(this.dayAlreadySettingChk(day)){
              //     return ' configured_day';
              // }
              // // 未設定
              // else{
              //     // console.log('dayclassstat 不一致', day);
              //     return ' ';
              // }
              return '';
          }
      },
    }
}
</script>
